module.exports = __webpack_public_path__ + "assets/img/work.6bc2ddca.svg";